module.exports = __webpack_public_path__ + "static/media/angle-double-left.a1c0db22.svg";